"use client";
import FormCard from "@/modules/Astro/components/FormCard";
import React, { useEffect, useState } from "react";
import styles from "./DetailsForm.module.scss";
import { genderData } from "@/modules/Astro/Data";
import { useRouter } from "next/navigation";
import {
  AstroUserData,
  AstroUserDataReq,
  UserAstroProfile,
} from "@/modules/Astro/Enum";
import { FormResponse } from "@/types/common.types";
import {
  addAstroProfiles,
  deleteAstroProfile,
  fetchAstroProfiles,
} from "@/services/astro.service";
import { formFields } from "@/modules/Astro/components/FormCard/formFields";
import { getFormatDateFromPrediction2 } from "@/modules/Astro/helper";
import useAppContext from "@/customhooks/useAppContext";
import KundliItems from "@/modules/Astro/components/KundliItems";
import { Astro_Strings } from "@/modules/Astro/Strings";
import Popup from "@/common/components/Popup/Popup";

const DetailsForm = () => {
  const router = useRouter();
  const context = useAppContext();
  const token = context?.auth?.token ?? "";
  const [initialData, setInitialData] = useState<{
    [x: string]: FormResponse;
  }>();
  const [submit, setSubmit] = useState(false);
  const [formData, setFormdata] = useState<AstroUserDataReq>();
  const [astroProfiles, setAstroProfiles] = useState<UserAstroProfile[]>([]);
  const [isPopUp, setPopUp] = useState<boolean>(false);
  const [itemToRemove, setItemToRemove] = useState<number>(-1);

  const handleSubmit = () => {
    setSubmit(true);
    setTimeout(() => setSubmit(false), 500);
  };

  const getFormData = (formName: string, data: AstroUserData | null) => {
    if (!data) setSubmit(false);
    else {
      setFormdata((prev) => ({
        ...prev,
        [formName]: { ...data, tob: `${data?.tob}:00` },
      }));
    }
  };

  const checkIfNewProfile = (
    newProfileData: AstroUserData,
    initProfileData: FormResponse
  ) => {
    if (
      newProfileData?.pob !== initProfileData?.place_of_birth ||
      newProfileData?.tob !== initProfileData?.time_of_birth ||
      newProfileData?.name !== initProfileData?.name ||
      getFormatDateFromPrediction2(newProfileData?.dob).toDateString() !==
        getFormatDateFromPrediction2(
          initProfileData?.DOB as string
        ).toDateString()
    ) {
      token && addAstroProfiles(newProfileData, token);
    }
  };

  const getAstroProfiles = async () => {
    const res = await fetchAstroProfiles(token);
    if (res?.data) setAstroProfiles(res?.data ?? []);
  };
  const handleDelete = async () => {
    const res = await deleteAstroProfile(itemToRemove, token);
    if (res?.message === "success") {
      setAstroProfiles((items) =>
        items?.filter(({ id }) => id !== itemToRemove)
      );
    }
    setPopUp(false);
  };
  const onPopupClose = () => {
    setPopUp(!isPopUp);
  };

  useEffect(() => {
    token && getAstroProfiles();
  }, [token]);

  useEffect(() => {
    if (formData?.maleData && formData?.femaleData) {
      checkIfNewProfile(formData?.maleData, initialData?.M ?? {});
      checkIfNewProfile(formData?.femaleData, initialData?.F ?? {});
      const pushUrl = `/kundli-match/result?data=${JSON.stringify(formData)}`;
      router.push(pushUrl);
      // router.replace({
      //   pathname: "",
      //   query: {
      //     data: JSON.s
      //     tringify(formData),
      //   },
      // });
      // router.replace('/astro/kundli-center/kundli-match/result')
    }
  }, [formData]);

  const onProfileSelect = (profile: any) => {
    setInitialData((prev) => ({ ...prev, [profile.gender]: profile }));
  };

  return (
    <div className={styles.kundliMatchCont}>
      <p className={styles.description}>
        {Astro_Strings.KUNDLI_MATCH_DESCRIPTION}
      </p>
      <div className={styles.profilesCont}>
        <p className={styles.heading}>Previous Profiles</p>
        <KundliItems
          userGender={"m"}
          items={astroProfiles}
          setPopUp={setPopUp}
          setItemToRemove={setItemToRemove}
          onProfileSelect={onProfileSelect}
        />
      </div>
      <form
        className={styles.centerWrapper}
        onSubmit={(e) => e.preventDefault()}
      >
        <p className={styles.heading}>Find the details below</p>
        <FormCard
          gender={genderData.male}
          initialData={initialData?.M ?? {}}
          submit={submit}
          onSubmit={getFormData}
          formFields={formFields}
        />
        <FormCard
          gender={genderData.female}
          initialData={initialData?.F ?? {}}
          submit={submit}
          onSubmit={getFormData}
          formFields={formFields}
        />
        <button onClick={handleSubmit}>Match</button>
      </form>
      <Popup show={isPopUp} onClose={onPopupClose}>
        <div className={styles.popupWrapper}>
          <div className={styles.popUpContainer}>
            <h3>{Astro_Strings.DELETE_POPUP_TITLE}</h3>
            <p>{Astro_Strings.DELETE_POPUP_DESC}</p>
            <ul className={styles.optionsWrapper}>
              <li onClick={() => onPopupClose()}>No</li>
              <li onClick={handleDelete}>Yes</li>
            </ul>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default DetailsForm;
